import React, {Component} from 'react'
import ReactGA from 'react-ga'
import {YMInitializer} from 'react-yandex-metrika'
import $ from 'jquery'
import styles from './App.css'
import {GOOGLE_ANALYTICS_UA} from './Constants/ga'
import Structure from './Components/Structure'


class App extends Component {

    constructor(props) {
        super(props)

        ReactGA.initialize(GOOGLE_ANALYTICS_UA)
        ReactGA.pageview(window.location.pathname)
        // YM 64678060 - me
        // YM 67481329 - Tito

    }

    getResumeData() {
        $.ajax({
            url: '/resumeData.json',
            dataType: 'json',
            cache: false,
            success: function (data) {
                this.setState({resumeData: data})
            }.bind(this),
            error: function (xhr, status, err) {
                console.log(err)
                alert(err)
            },
        })
    }

    componentDidMount() {
        window.scrollTo(0, 0)
        this.getResumeData()
    }
    render() {
        return (
            <div className="App">
                <YMInitializer accounts={[64678060, 67481329]} options={{webvisor: true}} />
                <Structure data={this.state} />
            </div>
        )
    }
}
export default App



// WEBPACK FOOTER //
// ./src/App.js